const pattern = /{attachments:((?:[^;}];?)+)}/;

export default pattern;